<template>
    <div class="survey-int-container">
        <span>{{field.name}}</span>
        <md-field v-bind:class="{'has-error': errors.has(field.id) }">
            <label>{{readonlyMode ? '': field.placeholder || "Wprowadź tekst"}}</label>
            <md-input v-model="model" v-on:change="onModelChange(field.id)"
                      v-validate="'numeric|min_value:0'"
                      type="text"
                      v-bind:name="field.id"
                      :disabled="readonlyMode"
            ></md-input>
            <span class="md-error help is-danger"
                  v-bind:class="{'visible': errors.has(field.id) }">
                                Wpisz dodatnią liczbę.</span>
        </md-field>
    </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'SurveyInt',
  data() {
    return {
      model: this.field.value,
      readonlyMode: store.state.visit.readonlyMode,
    };
  },
  methods: {
    onModelChange(fieldName) {
      if (this.errors.has(fieldName)) {
        return;
      }

      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
  props: ['field'],
};
</script>

<style src="./SurveyInt.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyInt/SurveyInt.vue